import { useState } from 'react';
import { updatePassword } from './agrisci-auth';

const C = {
    darkGreen:'#0D2818', midGreen:'#1A3A2A', accent:'#2D5A3D',
    gold:'#C9A84C', cream:'#F5F0E8', creamDark:'#EDE6D8',
    text:'#1A2E1E', textMuted:'#5A7A64', white:'#FFFFFF', red:'#C0392B',
};

const LABELS = {
    el: {
          title: 'Καλώς ήρθες!', subtitle: 'Όρισε τον κωδικό πρόσβασής σου',
          newPw: 'Νέος κωδικός', confirmPw: 'Επιβεβαίωση κωδικού',
          submit: 'Ορισμός κωδικού', loading: 'Αποθήκευση...',
          errMismatch: 'Οι κωδικοί δεν ταιριάζουν.',
          errShort: 'Ο κωδικός πρέπει να έχει τουλάχιστον 8 χαρακτήρες.',
          errGeneric: 'Κάτι πήγε στραβά. Δοκίμασε ξανά.',
          doneTitle: 'Ο λογαριασμός σου είναι έτοιμος!',
          doneSubtitle: 'Έχεις πρόσβαση και στα δύο εργαλεία μας:',
          nutritionCTA: 'Έχεις πρόσβαση και στο μοντέλο θρέψης εδώ →',
          continueCTA: 'Συνέχεια στο Μοντέλο Άρδευσης →',
    },
    en: {
          title: 'Welcome!', subtitle: 'Set your password',
          newPw: 'New password', confirmPw: 'Confirm password',
          submit: 'Set password', loading: 'Saving...',
          errMismatch: 'Passwords do not match.',
          errShort: 'Password must be at least 8 characters.',
          errGeneric: 'Something went wrong. Please try again.',
          doneTitle: 'Your account is ready!',
          doneSubtitle: 'You have access to both our tools:',
          nutritionCTA: 'You also have access to the nutrition model here →',
          continueCTA: 'Continue to Irrigation Model →',
    },
    it: {
        title: 'Benvenuto!', subtitle: 'Imposta la tua password',
        newPw: 'Nuova password', confirmPw: 'Conferma password',
        submit: 'Imposta password', loading: 'Salvataggio...',
        errMismatch: 'Le password non coincidono.',
        errShort: 'La password deve avere almeno 8 caratteri.',
        errGeneric: 'Qualcosa è andato storto. Riprova.',
        doneTitle: 'Il tuo account è pronto!',
        doneSubtitle: 'Hai accesso a entrambi i nostri strumenti:',
        nutritionCTA: 'Hai accesso anche al modello di nutrizione qui →',
        continueCTA: 'Continua al Modello di Irrigazione →',
    },
    es: {
        title: '¡Bienvenido!', subtitle: 'Establece tu contraseña',
        newPw: 'Nueva contraseña', confirmPw: 'Confirmar contraseña',
        submit: 'Establecer contraseña', loading: 'Guardando...',
        errMismatch: 'Las contraseñas no coinciden.',
        errShort: 'La contraseña debe tener al menos 8 caracteres.',
        errGeneric: 'Algo salió mal. Inténtalo de nuevo.',
        doneTitle: '¡Tu cuenta está lista!',
        doneSubtitle: 'Tienes acceso a nuestras dos herramientas:',
        nutritionCTA: 'También tienes acceso al modelo de nutrición aquí →',
        continueCTA: 'Continuar al Modelo de Riego →',
    },
    fr: {
        title: 'Bienvenue !', subtitle: 'Définissez votre mot de passe',
        newPw: 'Nouveau mot de passe', confirmPw: 'Confirmer le mot de passe',
        submit: 'Définir le mot de passe', loading: 'Enregistrement...',
        errMismatch: 'Les mots de passe ne correspondent pas.',
        errShort: 'Le mot de passe doit contenir au moins 8 caractères.',
        errGeneric: 'Une erreur est survenue. Veuillez réessayer.',
        doneTitle: 'Votre compte est prêt !',
        doneSubtitle: 'Vous avez accès à nos deux outils :',
        nutritionCTA: 'Vous avez aussi accès au modèle de nutrition ici →',
        continueCTA: "Continuer vers le Modèle d'Irrigation →",
    },
};

export default function SetPasswordScreen({ lang = 'el', onDone, setLang }) {
    const L = LABELS[lang] || LABELS.el;
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);

  async function handleSubmit() {
        setError('');
        if (password.length < 8) { setError(L.errShort); return; }
        if (password !== confirm) { setError(L.errMismatch); return; }
        setLoading(true);
        try {
                await updatePassword(password);
                setDone(true);
        } catch (err) {
                setError(L.errGeneric);
        } finally {
                setLoading(false);
        }
  }

  const cardStyle = {
        background: C.cream, borderRadius: 20, padding: '36px 28px',
        maxWidth: 380, width: '100%', textAlign: 'center',
  };

  if (done) {
        return (
                <div style={{ minHeight: '100vh', background: C.darkGreen,
                                    fontFamily: "'Inter',-apple-system,sans-serif",
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
    {setLang && (
        <div style={{ display: 'flex', gap: 6, marginBottom: 24 }}>
    {['el', 'en', 'it', 'es', 'fr'].map(l => (
        <button key={l} onClick={() => setLang(l)} style={{
        padding: '4px 10px', borderRadius: 20,
        border: '1.5px solid ' + (lang === l ? C.gold : C.gold + '44'),
        background: lang === l ? C.gold : 'transparent',
        color: lang === l ? C.darkGreen : C.gold,
        fontSize: 11, fontWeight: 700, cursor: 'pointer',
    }}>
{l === 'el' ? '🇬🇷 ΕΛ' : l === 'en' ? '🇬🇧 EN' : l === 'it' ? '🇮🇹 IT' : l === 'es' ? '🇪🇸 ES' : '🇫🇷 FR'}
</button>
    ))}
</div>
    )}
          <div style={cardStyle}>
              <div style={{ fontSize: 40, marginBottom: 12 }}>✅</div>
          <div style={{ fontSize: 20, fontWeight: 800, color: C.text, marginBottom: 6 }}>{L.doneTitle}</div>
          <div style={{ fontSize: 13, color: C.textMuted, marginBottom: 24 }}>{L.doneSubtitle}</div>

          <a href="https://nutrition.agrisci-solutions.com/" style={{
              display: 'block', width: '100%', padding: '13px', borderRadius: 10,
              background: C.gold, color: C.darkGreen, textDecoration: 'none',
              fontSize: 14, fontWeight: 800, marginBottom: 12, boxSizing: 'border-box',
}}>
{L.nutritionCTA}
</a>

          <button onClick={onDone} style={{
              width: '100%', padding: '13px', borderRadius: 10, background: C.darkGreen,
              color: C.gold, border: 'none', fontSize: 14, fontWeight: 800, cursor: 'pointer',
}}>
{L.continueCTA}
</button>
  </div>
  </div>
    );
}

  return (
        <div style={{ minHeight: '100vh', background: C.darkGreen,
                          fontFamily: "'Inter',-apple-system,sans-serif",
                          display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
{setLang && (
    <div style={{ display: 'flex', gap: 6, marginBottom: 24 }}>
{['el', 'en', 'it', 'es', 'fr'].map(l => (
    <button key={l} onClick={() => setLang(l)} style={{
    padding: '4px 10px', borderRadius: 20,
    border: '1.5px solid ' + (lang === l ? C.gold : C.gold + '44'),
    background: lang === l ? C.gold : 'transparent',
    color: lang === l ? C.darkGreen : C.gold,
    fontSize: 11, fontWeight: 700, cursor: 'pointer',
}}>
{l === 'el' ? '🇬🇷 ΕΛ' : l === 'en' ? '🇬🇧 EN' : l === 'it' ? '🇮🇹 IT' : l === 'es' ? '🇪🇸 ES' : '🇫🇷 FR'}
</button>
    ))}
</div>
    )}
      <div style={cardStyle}>
            <div style={{ fontSize: 11, color: C.gold, fontWeight: 700, letterSpacing: '0.15em',
                                  textTransform: 'uppercase', marginBottom: 6 }}>AgriSci Solutions</div>
        <div style={{ fontSize: 20, fontWeight: 800, color: C.text, marginBottom: 4 }}>{L.title}</div>
        <div style={{ fontSize: 13, color: C.textMuted, marginBottom: 28 }}>{L.subtitle}</div>

        <input type="password" value={password} placeholder={L.newPw}
          onChange={e => { setPassword(e.target.value); setError(''); }}
                              style={{ width: '100%', padding: '12px 16px', borderRadius: 10,
                                                 border: `1.5px solid ${error ? C.red : C.creamDark}`,
                                                 background: C.white, fontSize: 14, color: C.text, outline: 'none',
                                                 boxSizing: 'border-box', marginBottom: 10 }} />

        <input type="password" value={confirm} placeholder={L.confirmPw}
          onChange={e => { setConfirm(e.target.value); setError(''); }}
                              onKeyDown={e => e.key === 'Enter' && handleSubmit()}
                      style={{ width: '100%', padding: '12px 16px', borderRadius: 10,
                                         border: `1.5px solid ${error ? C.red : C.creamDark}`,
                                         background: C.white, fontSize: 14, color: C.text, outline: 'none',
                                         boxSizing: 'border-box', marginBottom: 8 }} />

{error && <div style={{ color: C.red, fontSize: 12, marginBottom: 8, fontWeight: 600 }}>{error}</div>}

        <button onClick={handleSubmit} disabled={loading || !password || !confirm}
          style={{ width: '100%', padding: '13px', borderRadius: 10, background: C.darkGreen,
                             color: C.gold, border: 'none', fontSize: 15, fontWeight: 800,
                             cursor: loading ? 'wait' : 'pointer', marginTop: 4,
                             opacity: (!password || !confirm) ? 0.6 : 1 }}>
{loading ? L.loading : L.submit}
</button>
  </div>
  </div>
  );
}
